const defaultData = {
  data: [],
  status: 'idle',
  error: ''
};

const tradeInquiryReducer = (state = defaultData, action) => {
  switch (action.type) {
    case 'GET_TRADE_INQUIRY_REQUEST':
      return {
        ...state,
        status: 'pending'
      };
    case 'GET_TRADE_INQUIRY_FAILURE':
      return {
        ...state,
        status: 'rejected',
        error: action.payload
      };
    case 'GET_TRADE_INQUIRY_SUCCESS':
      return {
        ...state,
        status: 'resolve',
        data: action.payload.data.data
      };
    case 'RESET_TRADE_INQUIRY':
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
};

export { tradeInquiryReducer };
